import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default function Hero() {
  const navigate = useNavigate();

  const slides = [
    {
      id: 1,
      image: '/images/belleza-boutique.jpg',
      title: 'Tu Rutina de Belleza Ideal',
      subtitle: 'PRODUCTOS EXCLUSIVOS SELECCIONADOS PARA TI',
      tagline: 'LLEVA EL SALÓN A TU CASA',
      buttonText: 'VISITAR TIENDA',
      path: '/products'
    },
    {
      id: 2,
      image: '/images/frahda-hero-bg.jpg',
      title: 'Toma Una Cita Aquí',
      subtitle: 'FRAHDA STUDIO | MEJOR OPCIÓN EN BELLEZA PERSONALIZADA',
      tagline: 'PREPÁRATE PARA TU MEJOR VERSIÓN',
      buttonText: 'AGENDAR YA',
      path: '/agendamiento'
    }
  ];

  return (
    <section className="relative h-[80vh] w-full mt-[72px]">
      <Swiper
        modules={[Autoplay, EffectFade, Pagination, Navigation]}
        effect="fade"
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        navigation={true}
        loop={true}
        className="h-full w-full group"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id} className="relative h-full w-full">
            <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-primary-dark transition-transform duration-700"
              style={{ backgroundImage: `url('${slide.image}')` }}
              aria-label={`Hero sección ${slide.title}`}
            />
            
            {/* Overlay oscuro para legibilidad */}
            <div className="absolute inset-0 bg-black/40" />

            {/* Contenido centrado */}
            <div className="relative z-10 flex h-full flex-col items-center justify-center text-center px-4">
              <div className="max-w-4xl animate-fadeIn">
                <h1 className="font-serif font-black text-white text-5xl md:text-6xl lg:text-7xl tracking-tight drop-shadow-lg">
                  {slide.title}
                </h1>

                <p className="mt-4 font-sans text-white text-sm md:text-base font-medium tracking-wide drop-shadow-md">
                  {slide.subtitle}
                </p>

                <div className="mt-6 inline-block border border-white/60 px-8 py-3 bg-black/20 backdrop-blur-[2px]">
                  <h2 className="font-serif font-bold text-white text-xl md:text-2xl drop-shadow-md tracking-wider">
                    {slide.tagline}
                  </h2>
                </div>

                <div className="mt-8">
                  <button
                    onClick={() => navigate(slide.path)}
                    type="button"
                    className="inline-flex items-center justify-center px-8 py-3 bg-[#B4897F] text-white font-bold tracking-wider hover:bg-[#A67A6F] transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/50 shadow-lg"
                  >
                    {slide.buttonText}
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
        
        {/* Custom styles for Swiper navigation/pagination */}
        <style>{`
          .swiper-pagination-bullet {
            background: white;
            opacity: 0.5;
          }
          .swiper-pagination-bullet-active {
            background: #B4897F;
            opacity: 1;
          }
          .swiper-button-next, .swiper-button-prev {
            color: white;
            opacity: 0;
            transition: opacity 0.3s;
          }
          .group:hover .swiper-button-next,
          .group:hover .swiper-button-prev {
            opacity: 0.7;
          }
          .swiper-button-next:hover, .swiper-button-prev:hover {
            opacity: 1 !important;
            color: #B4897F;
          }
        `}</style>
      </Swiper>
    </section>
  );
}